export default __webpack_public_path__ + "static/soehne-web-dreiviertelfett-kursiv-5ca4db854c635c55c59ab2d9346b1057.woff";